export default __webpack_public_path__ + "static/media/Helm of the Fallen Empire (nm).cb3499b9.jpg";